import './ox-input-nodes'

import { html } from 'lit'
import { customElement } from 'lit/decorators.js'

import { OxPropertyEditor, PropertySpec } from '@operato/property-editor'

@customElement('ox-property-editor-nodes')
export class PropertyEditorNodes extends OxPropertyEditor {
  editorTemplate(value: string[], spec: PropertySpec) {
    return html` <ox-input-nodes .value=${value}></ox-input-nodes> `
  }
}
